export const ALL_VALUE = "all";

export const filterList = (value) => {
  if (value === ALL_VALUE || value == null || value === "") return [];
  return (Array.isArray(value) ? value : [value]).map(String).filter(Boolean);
};

export const encodeFilterList = (values, numeric = false) => {
  const next = [...values].map(String);
  if (numeric) next.sort((a, b) => Number(a) - Number(b));
  else next.sort();
  return next.length ? next : ALL_VALUE;
};

export const visnList = filterList;
export const encodeVisnList = (values) => encodeFilterList(values, true);

// Only filters the current tab actually applies should narrow the shared
// VISN/Site/Specialty lists. Analysis, Retention, and LTV hide State and
// RISE VISN (and Analysis/LTV also hide Report month) and their requests
// ignore those params — if they still scoped the option fetch, dropdowns
// would omit choices the visible report still includes.
export const optionListScope = (tab, { visn, stationId, specialty, licenseState, riseVisn, reportMonth }) => ({
  visn,
  stationId,
  specialty,
  licenseState: tab === "financialreview" ? licenseState : ALL_VALUE,
  riseVisn: tab === "financialreview" ? riseVisn : ALL_VALUE,
  reportMonth: tab === "financialreview" || tab === "retention" ? reportMonth : "",
});
